import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { jsPDF } from "jspdf";
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { CustomerService } from "../../shared/customer.service";

@Injectable({
  providedIn: 'root'
})
export class PrintcustomerService {
  CustomerList: any[] = [];

  constructor(private httpClient: HttpClient,
    private customerService: CustomerService, public datePipe: DatePipe,) { }

  getRptLoanList(rptSearchData: any) {

    this.customerService.FetchReportsCustomerList(rptSearchData)
      .toPromise()
      .then(data => {
          if (data.length > 0) {
            this.ReportGenerateList(data, this.datePipe);
          }
          else {
            console.log('data not found!');
          }
      })
      .catch(err => { console.log(err) });
  }

  //--------------------------------------------------
  // Printing the documents as a lists.  
  ReportGenerateList(CustomerList, datePipe: DatePipe) {

    var generateData = function (CustomerList) {

      var result = [];
      var itemData = [{}];
      // let todayDate = new Date(); 
      // console.log(datePipe.transform(todayDate, 'yyyy-MM-dd'));

      for (var i = 0; i < CustomerList.length; i += 1) {
        itemData[i] = {
          'SI No.': CustomerList[i].Id.toString(),
          'Customer No.': CustomerList[i].Id.toString(),
          'Name': CustomerList[i].CustomerName.toString(),
          'Address': CustomerList[i].CustomerAddress.toString(),
          'PAN No.': CustomerList[i].PANNo.toString(),
          'Proof Type': CustomerList[i].AddressProofType.toString(),
          'Proof No':  CustomerList[i].AddressProofNo.toString(),
          'Proof Expiry': CustomerList[i].AddressProofValidity.toString(),
          'Mobile No.': CustomerList[i].Mobile.toString(),
          // 'DOB/Age': datePipe.transform(CustomerList[i].DOB, 'dd-MM-yyyy').toString(),
          // 'App. Date': datePipe.transform(CustomerList[i].ApplicationDate, 'dd-MM-yyyy').toString(),
        };
      }

      // 'Date': datePipe.transform(CustomerList[i].LoanApprovedDate, 'dd-MM-yyyy'),

      for (var i = 0; i < CustomerList.length; i += 1) {
        itemData[i]['SI No.'] = (i + 1).toString();
        result.push(Object.assign({}, itemData[i]));
      }

      return result;
    };


    function createHeaders(HeaderName) {

      var HeaderResult = [];
      for (var i = 0; i < HeaderName.length; i += 1) {
        HeaderResult.push({
          id: HeaderName[i],
          name: HeaderName[i],
          prompt: HeaderName[i],
          width: 75,
          align: "left",
          padding: 0,
        });
      }
      // console.log("--HeaderResult--");
      // console.log(HeaderResult);
      return HeaderResult;
    }

    var headers = createHeaders([
      "SI No.",
      "Customer No.",
      "Name",
      "Address",
      "PAN No.",
      "Proof Type",
      "Proof No",
      "Proof Expiry",
      "Mobile No.",
      // "DOB/Age",
      // "App. Date",
    ]);

    // Document of 210mm wide and 297mm high
    // new jsPDF('p', 'mm', [297, 210]);
    // // Document of 297mm wide and 210mm high
    // new jsPDF('l', 'mm', [297, 210]);
    // // Document of 5 inch width and 3 inch high
    // new jsPDF('l', 'in', [3, 5]);

    // let pdf = new jsPDF('l', 'pt', 'legal');    
    // let pdf = new jsPDF('l', 'pt', 'letter');
    let pdf = new jsPDF('p', 'pt', 'A4');
    //   let pdf = new JsPDF(  
    //     Orientation, // Landscape or Portrait     
    //     unit, // mm, cm, in     
    //     format // A2, A4 etc  
    // );  

    pdf.setProperties({
      title: 'Customers Report',
      subject: 'Info about PDF',
      author: 'PDFAuthor',
      keywords: 'Customers Report, javascript, web 2.0, ajax',
      creator: 'SRI'
    });

    let todayDate = new Date();

    // Top HEADER
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(14);
    pdf.setFont('arial', 'normal');
    pdf.text("Society For Rural Improvements", 210, 40);  // 40 is the height
    pdf.text("Customer Report", 245, 60);
    // pdf.text("Loan Application on  " + datePipe.transform(todayDate, 'dd-MM-yyyy'), 245, 80);
    pdf.setLineWidth(1.5);
    pdf.line(5, 105, 590, 105)
    // Top HEADER END 

    // Second Top HEADER
    pdf.setFontSize(10);
    pdf.setFont('arial', 'normal');
    pdf.text("Loan Type :" + CustomerList[0].SchemeName.toString(), 25, 120);
    pdf.text("Centre      :" + CustomerList[0].CentreName.toString(), 25, 140);
    // pdf.text("Status      :" + CustomerList[0].LoanApprovedStatus.toString(), 440, 120);
    pdf.text("Branch      :" + CustomerList[0].CustomerBranchName.toString(), 440, 140);
    pdf.line(5, 150, 590, 150)   // x-axis, -x-axix,  y-axis  , -y-axix
    // Top HEADER END 

    // var doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape" });
    // doc.table(1, 1, generateData(100), headers, { autoSize: true });

    // Body
    pdf.table(25, 165, generateData(CustomerList), headers, { autoSize: false });
    pdf.output('dataurlnewwindow');
    // Body End
  }
  ////
}
